import { dowloadExcel, generateExcelBlob } from "@/composables/Excel";
import { exportExcelData, ExportExcelResponse } from "@/services/cardapio/ExcelHandler";
import useAlert from "@/composables/Alert";
import { useStore } from "vuex";
import { ConcessionariaModel } from "@/models/ConcessionariaModel";

export default function UseHandleExportXlsx() {
    const { showTimeAlert } = useAlert();
    const store = useStore();

    const handleExport = async (type: string) => {
        const concessionariaSelected: ConcessionariaModel = store.getters.concessionariaSelectedInfo;
        const nameConcessionaria =
            concessionariaSelected?.nomeFantasia?.replace(/\s+/g, "_").toUpperCase() ?? "Concessionaria";
        const codConcessionaria = localStorage.getItem("filtroConcessionaria");

        const nameFile = {
            mo: `EXPORTACAO_MO_VINCULO_${nameConcessionaria}`,
            itens: `EXPORTACAO_PECA_${nameConcessionaria}`,
            pneus: `EXPORTACAO_PNEUS_${nameConcessionaria}`,
            alacarte: `EXPORTACAO_ALACARTE_${nameConcessionaria}`,
        };

        if (!codConcessionaria) {
            const errorResponse = {
                message: "Código da concessionária não encontrado",
                errors: "Nenhum código encontrado em localStorage",
            };
            showTimeAlert(errorResponse.message, "error");
            return errorResponse;
        }


        await exportExcelData(Number(codConcessionaria), type)
            .then((res) => {
                if (res instanceof Blob) {
                    const blob = generateExcelBlob(res);
                    dowloadExcel(blob, nameFile[type] ?? nameConcessionaria);
                }
                showTimeAlert("Exportação concluída com sucesso.");

            }).catch( async(error) => {
                if (error.response && error.response.data instanceof Blob) {
                    const text = await error.response.data.text();
                    try {
                        const json = JSON.parse(text);
                        showTimeAlert(json.errors, "error");
                    } catch (parseError) {
                        showTimeAlert("Erro desconhecido", "error");
                    }
                } else {
                    showTimeAlert("Erro desconhecido", "error");
                }
            });

    };

    return {
        handleExport,
    };
}
